<template>
  <div>
    <v-img :src="require(`@/assets/journey/${journey.image}`)" class="jcmobile pt-7" contain eager>
      <div class="text-right" style="margin-right:15%; margin-bottom: 5px;">
          <v-icon dark small @click="close2()">mdi-close</v-icon>
      </div>
      <div class="jcboxMobile font-dm">
        <div class="jcboxEnd">
          <div class="jcboxContent pa-2 small-category text-center rounded-un">
            {{ journey.topText }}
          </div>
          <div class="jcboxEndBackground rounded-un">
            <div class="arrow-down arrow-down-purple"></div>
          </div>
          <div class="arrow-down border-pink"></div>
        </div>
      </div>
    </v-img>
    <v-card flat dark color="#7D4CA8" class="pa-3 jorneyLetsGoMobile rounded-un text-center">
      <p class="small-category">
        {{ journey.bottomText }}
      </p>
      <v-btn color="white" class="rounded-un mt-5 color-purple" block depressed @click="send2()">
        {{ journey.button }}
      </v-btn>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    journey: Object,
    close: Function,
    send: Function,
  },
  methods: {
    close2() {
      this.$emit('click')
    },
    send2() {
      this.$emit('send')
    },
  },
}
</script>

<style></style>
